var React = require('react');

function Video (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(.333 .583)","stroke":"#5B00DB","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"m1.111 12.626 31.111-.252M6.389 3.611l7.778 8.333M18.611 3.611l7.778 8.333","key":0}),React.createElement("rect",{"x":"1.111","y":"3.333","width":"31.111","height":"27.222","rx":"3.333","key":1}),React.createElement("path",{"d":"M21.667 21.111 13.889 25v-7.778z","key":2})]));
}

Video.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34"};

module.exports = Video;

Video.default = Video;
